import React from "react";
import classnames from "classnames";
import { PAYLINE_API_OPTIONS } from "./types";

type ApiToggleProps = {
    label: string;
    value: string;
    onChange: (v: string) => void;
};

export function ApiToggle({ label, value, onChange }: ApiToggleProps) {
    return (
        <div data-testid="payline-api-toggle">
            <label className="payment-field-label__clz">{label}</label>
            <div className="api-toggle__clz">
                {PAYLINE_API_OPTIONS.map((option) => {
                    const isSelected = value === option;
                    return (
                        <button
                            key={option}
                            type="button"
                            data-testid={`payline-api-option-${option.toLowerCase()}`}
                            onClick={() => onChange(option)}
                            className={classnames("api-toggle-btn__clz", {
                                "api-toggle-btn--selected__clz": isSelected,
                            })}
                        >
                            {option}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
